module.exports = __webpack_public_path__ + "static/img/20170406112203_5672.2ba8293.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20170406112203_5672.jpg
// module id = ZM5+
// module chunks = 1